<template>
  <div>
    <v-data-table
      :headers="headers"
      :items="documents"
      :options.sync="options"
      :server-items-length="total"
      :loading="loading"
      expand-icon="$sort"
      hide-default-footer
      show-expand
      single-expand
    >
      <template v-slot:[`item.type`]="{ item }">
        {{ getDocumentTypeName(item.type) }}
      </template>
      <template v-slot:[`item.validTo`]="{ item }">
        {{ item.validTo | dateFormat('DD.MM.YYYY') }}
      </template>
      <template v-slot:[`item.dateOfDeprecation`]="{ item }">
        {{ item.dateOfDeprecation | dateFormat('DD.MM.YYYY') }}
      </template>
      <template v-slot:expanded-item="{ headers, item }">
        <td class="py-4" :colspan="headers.length">
          <div class="d-flex flex-column ml-6">
            <div v-for="file in item.files" :key="file.name" class="d-flex align-center mb-2">
              <v-icon class="mr-4 pointer" small @click="getFile(item, file)">$download</v-icon>
              <h4>{{ file.name }}</h4>
            </div>
          </div>
        </td>
      </template>
    </v-data-table>
    <v-pagination
      v-if="pageCount > 1"
      :value="options.page"
      :length="pageCount"
      @input="options.page = $event"
    />
  </div>
</template>

<script>
import Service from '@/services'
import { downloadFile } from '@/utils/helpers'

export default {
  name: 'TSLArchive',
  props: {
    contractorId: {
      type: String,
      required: true
    },
    contractorType: {
      type: Number,
      required: true
    }
  },
  data () {
    return {
      loading: true,
      total: 0,
      options: {},
      headers: [
        {
          text: this.$t('companiesDetails.type'),
          align: 'start',
          value: 'type',
          sortable: false
        },
        {
          text: this.$t('companiesDetails.date'),
          value: 'validTo',
          sortable: false
        },
        {
          text: this.$t('companiesDetails.name'),
          value: 'description',
          sortable: false
        },
        {
          text: this.$t('companiesDetails.deprecation'),
          value: 'dateOfDeprecation',
          sortable: false
        }
      ],
      documents: []
    }
  },
  computed: {
    pageCount () {
      return Math.ceil(this.total / this.options.itemsPerPage)
    },
    documentTypeNames () {
      if (this.contractorType === 1) { // Client
        return {
          5: this.$t('tslContractors.documentCategories.vat'),
          6: this.$t('tslContractors.documentCategories.certificates'),
          7: this.$t('tslContractors.documentCategories.other')
        }
      } else { // Carrier
        return {
          8: this.$t('tslContractors.documentCategories.insurance'),
          9: this.$t('tslContractors.documentCategories.license'),
          10: this.$t('tslContractors.documentCategories.vat'),
          11: this.$t('tslContractors.documentCategories.certificates'),
          12: this.$t('tslContractors.documentCategories.other')
        }
      }
    }
  },
  watch: {
    options: {
      handler () {
        this.getDocuments()
      },
      deep: true
    }
  },
  methods: {
    getDocumentTypeName (type) {
      return this.documentTypeNames[type] || type
    },
    async getDocuments () {
      this.loading = true
      const { page, itemsPerPage } = this.options

      try {
        const { data } = await Service.get('/TSLContractor/GetArchivedDocuments', {
          contractorId: this.contractorId,
          page: page,
          pageSize: itemsPerPage
        })
        this.documents = data.results
        this.total = data.count
      } catch (e) {
        this.$store.dispatch('setErrorNotification', e.response?.data || 'Error loading archived documents')
      } finally {
        this.loading = false
      }
    },
    async getFile (document, file) {
      try {
        const fileName = file.name
        const url = `/TSLContractor/GetDocumentFile?contractorId=${this.contractorId}&documentId=${document.id}&fileName=${encodeURIComponent(fileName)}`
        const { data } = await Service.getFile(url)
        downloadFile(file, data)
      } catch (e) {
        this.$store.dispatch('setErrorNotification', e.response?.data || 'Error downloading file')
      }
    }
  }
}
</script>
